
import usData from "./us.json";
import caData from "./ca.json";
import euData from "./eu.json";
import chData from "./ch.json";
import ukData from "./uk.json";
import sgData from "./sg.json";
import {JURISDICTIONS} from "../../../../../config";
import {FILTERS} from "../filters";

function mergeMap(acc, monthlyData, jurisdiction) {
  const key = `${monthlyData.year}-${monthlyData.month}`;
  
  if (!acc.get(key)) {
    acc.set(key, {});
  };
  
  acc.get(key)[jurisdiction] = monthlyData.data;
  return acc;
}

const dataPerMonth = new Map();

usData.result.reduce((acc, x) => mergeMap(acc, x, JURISDICTIONS.USA), dataPerMonth);
caData.result.reduce((acc, x) => mergeMap(acc, x, JURISDICTIONS.CANADA), dataPerMonth);
euData.result.reduce((acc, x) => mergeMap(acc, x, JURISDICTIONS.EU), dataPerMonth);
chData.result.reduce((acc, x) => mergeMap(acc, x, JURISDICTIONS.SWITZERLAND), dataPerMonth);
ukData.result.reduce((acc, x) => mergeMap(acc, x, JURISDICTIONS.UK), dataPerMonth);
sgData.result.reduce((acc, x) => mergeMap(acc, x, JURISDICTIONS.SG), dataPerMonth);


function getXAxisLabel(data, currentFilter) {
  // With dates, return only the month
  const split = data.name.split("-");

  if (currentFilter.label === FILTERS.ALL_TIME.label) {
    return split[1]; // Just the month's number as there isn't enough space
  } else if (currentFilter.label === FILTERS.YEARLY.label) {
    const date = new Date();
    date.setDate(1); // Otherwise setMonth won't work well when today is 31st
    date.setMonth(split[1] - 1);
    return date.toLocaleString("en", {month: "short"})
  } else {
    return data.name;
  }
}

export default {
  data: dataPerMonth,
  getXAxisLabel: getXAxisLabel,
}